export default __webpack_public_path__ + "static/media/logo.36644277.svg";